import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { PositionedSpinner } from "../../../../../../../components/ui/PositionedSpinner";
import { useCurrentOrganisationId } from "../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { ChangeTeamImpactCountSidebarModel } from "./ChangeTeamImpactCountSidebar_model";
import { PieChart } from "@flightpath/coreui/dist/widgets/pie";
import { PieTooltip } from "../../../../../projects/view/components/ReportingPie";
import { useHref } from "react-router-dom";

export interface ImpactCountProps {
  userId: number;
  userName: string;
}

export const ChangeTeamImpactCountSidebar: React.FC<ImpactCountProps> = observer(props => {
  const { userId, userName } = props;
  const basename = useHref("/");
  const organisationId = useCurrentOrganisationId();
  const [model, setModel] = useState(
    () => new ChangeTeamImpactCountSidebarModel(organisationId, userId, userName, basename)
  );

  useEffect(() => {
    setModel(new ChangeTeamImpactCountSidebarModel(organisationId, userId, userName, basename));
    // eslint-disable-next-line
  }, [userId]);

  useEffect(() => {
    model.onMount();
  }, [model]);

  if (!model || model.isLoading) return <PositionedSpinner />;

  return (
    <div style={{ width: "100%", height: "70vh" }}>
      <div className="w-100 h-100 d-flex  justify-content-center align-items-center">
        <PieChart
          data={model.drillDownPieData}
          tooltipFn={PieTooltip}
          colors={model.getPieColors()}
          hasLinkLabels={true}
          margin={{
            top: 120,
            right: 100,
            bottom: 100,
            left: 100
          }}
          onClickFn={model.onPieClick}
        />
      </div>
    </div>
  );
});
